import './style.css';

function install_contact_toolbar() {
    let div, sb, app, content_type, category_id, show_popup;

    app = document.querySelector('#app');
    content_type = app.getAttribute('data-content-type');
    category_id = app.getAttribute('data-category-id');
    show_popup = app.getAttribute('data-show-popup');

    sb = new Array();
    
    if (Graphite.config.contact.contact_no) {
        sb.push('<span data-cmd="phone" data-tippy="Phone"><a href="tel:' + Graphite.config.contact.contact_no + '"></a></span>');
    }

    if (Graphite.config.contact.facebook_id) {
        sb.push('<span data-cmd="facebook" data-tippy="Facebook"><a href="https://m.me/' + Graphite.config.contact.facebook_id + '"></a></span>');
    }

    if (Graphite.config.contact.line_id) {
        sb.push('<span data-cmd="line" data-tippy="Line"><a href="https://line.me/R/ti/p/' + encodeURIComponent(Graphite.config.contact.line_id) + '"></a></span>');
    }

    if (Graphite.config.contact.email) {
        sb.push('<span data-cmd="email" data-tippy="E-mail"><a href="mailto:' + Graphite.config.contact.email + '"></a></span>');
    }

    div = document.createElement('div');
    div.setAttribute('data-role', 'contact-toolbar');
    div.html(sb.join(''))

    if (Graphite.tippy) {
        div.querySelectorAll('[data-tippy]').forEach(el => {
            Graphite.tippy.mount(el, el.getAttribute('data-tippy'));
        })
    }

    document.body.append(div);
}

export { install_contact_toolbar }